import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { omit } from 'lodash';

import _FlashNotifications from './FlashNotifications';
import _FlashNotification from './FlashNotification';
import _FlashRedirect from './FlashRedirect';
import {
    addNotification,
    removeNotification,
    ADD_FLASH_NOTIFICATION,
    REMOVE_FLASH_NOTIFICATION
} from './actions';

// default state
export const defaultState = {
    notifications: {},
};

// reducers

export const reducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case ADD_FLASH_NOTIFICATION: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    [action.notification.id || uuidv4()]: {
                        timeout: 3000,
                        flavor: 'success',
                        ...action.notification,
                    },
                }
            };
        }

        case REMOVE_FLASH_NOTIFICATION:
            return {
                ...state,
                notifications: omit(state.notifications, [action.notificationId]),
            };

        default:
            return state;
    }
};

// actions
export const actions = { addNotification, removeNotification };

export const FlashRedirect = connect(
    undefined,
    (dispatch, ownProps) => ({
        addNotification: notification => dispatch(addNotification(notification)),
    })
)(_FlashRedirect);

//connector
export const FlashNotifications = connect(({ flash_notifications }, ownProps) => ({
    notifications: flash_notifications,
}))(_FlashNotifications);

export const FlashNotification = connect(
    ({ flash_notifications }, ownProps) => ({ notifications: flash_notifications }),
    (dispatch, ownProps) => ({
        removeNotification: () => dispatch(removeNotification(ownProps.notificationId)),
    })
)(_FlashNotification);
